module.exports = __webpack_public_path__ + "img/DE02817.f53726f9.svg";